import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { StrategyForm } from '../components/commercial/StrategyForm';
import { StrategyTable } from '../components/commercial/StrategyTable';
import { SearchBar } from '../components/users/SearchBar';
import { Breadcrumb } from '../components/common/Breadcrumb';
const breadcrumbItems = [{
  label: 'Planes y Estrategias',
  href: '#'
}, {
  label: 'Estrategias Comerciales'
}];
export const CommercialStrategy = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const handleEdit = strategy => {
    setSelectedStrategy(strategy);
    setIsFormOpen(true);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1355">
      <main className="pt-16 pl-64" data-id="element-1356">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1357">
          <div className="mb-8" data-id="element-1358">
            <Breadcrumb items={breadcrumbItems} data-id="element-1359" />
            <div className="flex justify-between items-center mt-4" data-id="element-1360">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1361">
                Estrategias Comerciales y Planes de Financiación
              </h1>
              <button onClick={() => {
              setSelectedStrategy(null);
              setIsFormOpen(true);
            }} className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1362">
                <PlusIcon className="h-5 w-5 mr-2" data-id="element-1363" />
                Nueva Estrategia
              </button>
            </div>
          </div>
          <div className="mb-6" data-id="element-1364">
            <SearchBar data-id="element-1365" />
          </div>
          <StrategyTable onEdit={handleEdit} data-id="element-1366" />
          {isFormOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1367">
              <div className="bg-white rounded-lg w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto" data-id="element-1368">
                <StrategyForm strategy={selectedStrategy} onClose={() => setIsFormOpen(false)} data-id="element-1369" />
              </div>
            </div>}
        </div>
      </main>
    </div>;
};